import moment from 'moment';

export enum NotificationType {
  AUTO_FAVORITE = 'AUTO_FAVORITE',
  ARRIVAL_DELAY = 'ARRIVAL_DELAY',
  VISIBILITY = 'VISIBILITY',
  READINESS = 'READINESS',
  OPS = 'OPS',
  ETL = 'ETL'
}

export const tmmName = (name: string) => {
  if (name === 'ops-manager') {
    return 'Ops Manager';
  }
  if (name === 'engineering') {
    return 'Engineering';
  }
  if (name === 'station-manager') {
    return 'Station manager';
  }
  return name;
};

export enum UserRole {
  MASTER = 'master',
  OCC = 'occ',
  OPS_MANAGER = 'ops_manager',
  PILOT = 'pilot',
  ENGINEER = 'engineer',
  CABIN_CREW = 'cabin_crew',
  STATION_MANAGER = 'station_manager',
  PAX_SERVICES = 'pax_services',
  DISPATCH = 'dispatch'
}

export const roleName = (role: UserRole | string) => {
  switch (role) {
    case UserRole.MASTER:
      return 'Master';
    case UserRole.ENGINEER:
      return 'Engineer';
    case UserRole.OPS_MANAGER:
      return 'Ops Manager';
    case UserRole.OCC:
      return 'OCC';
    case UserRole.CABIN_CREW:
      return 'Cabin Crew';
    case UserRole.STATION_MANAGER:
      return 'Station Manager';
    case UserRole.PILOT:
      return 'Pilot';
    case UserRole.PAX_SERVICES:
      return 'Pax Services';
    case UserRole.DISPATCH:
      return 'Dispatch';
    default:
      return role;
  }
};

const pilotMapping = {
  '[RETIMED] New STD: DD/MM HH:MM': `New STD: DD/MM HH:MM
New Call Time: DD/MM HH:MM`,
  'STD Retimed': `New STD: DD/MM HH:MM
New Call Time: DD/MM HH:MM`,
  '[DELAY] New ETD: DD/MM HH:MM (+Xxmin)': 'New ETD: DD/MM HH:MM (+Xxmin)',
  '[AOG]': 'Check with OCC for updates',
  '[CANCELLED]': 'Check with OCC for duty update',
  '[RTB] Technical Assistance Required': 'Standby for further',
  '[RTB] Station Assistance Required': 'Standby for further',
  '[ATB] Technical Assistance Required': 'Standby for further',
  '[ATB] Station Assistance Required': 'Standby for further',
  '[DIVERTED] Technical Assistance Required': 'Standby for further',
  '[DIVERTED] Station Assistance Required': 'Standby for further',
  '[NEW FLIGHT PLAN REQUIRED]': '',
  '[GATE CHANGE]': 'New Gate: [GATE]',
  'ETD Delayed': 'New ETD: DD/MM HH:MM (+Xxmin)',
  Other: ''
};

const engineeringMapping = {
  '[RETIMED] New STD: DD/MM HH:MM': 'New STD: DD/MM HH:MM',
  'STD Retimed': 'New STD: DD/MM HH:MM',
  '[DELAY] New ETD: DD/MM HH:MM (+Xxmin)': 'New ETD: DD/MM HH:MM (+Xxmin)',
  '[AOG]': 'Standby for further',
  '[CANCELLED]': 'Check with OCC for updates',
  '[RTB] Technical Assistance Required': 'Please standby at Gate [XX]',
  '[RTB] Station Assistance Required': 'Standby for further',
  '[ATB] Technical Assistance Required': 'Please standby at Gate [XX]',
  '[ATB] Station Assistance Required': 'Standby for further',
  '[DIVERTED] Technical Assistance Required': 'Please standby at Gate [XX]',
  '[DIVERTED] Station Assistance Required': 'Standby for further',
  '[NEW FLIGHT PLAN REQUIRED]': '',
  '[GATE CHANGE]': 'New Gate: [GATE]',
  'ETD Delayed': 'New ETD: DD/MM HH:MM (+Xxmin)',
  Other: ''
};

const opsMapping = {
  '[RETIMED] New STD: DD/MM HH:MM': 'New STD: DD/MM HH:MM',
  'STD Retimed': 'New STD: DD/MM HH:MM',
  '[DELAY] New ETD: DD/MM HH:MM (+Xxmin)': 'New ETD: DD/MM HH:MM (+Xxmin)',
  '[AOG]': 'No broadcast',
  '[CANCELLED]': 'No broadcast',
  '[RTB] Technical Assistance Required': 'Standby for further',
  '[RTB] Station Assistance Required': 'Standby for further',
  '[ATB] Technical Assistance Required': 'Standby for further',
  '[ATB] Station Assistance Required': 'Standby for further',
  '[DIVERTED] Technical Assistance Required': 'Standby for further',
  '[DIVERTED] Station Assistance Required': 'Standby for further',
  '[NEW FLIGHT PLAN REQUIRED]': '',
  '[GATE CHANGE]': 'No broadcast',
  'ETD Delayed': 'New ETD: DD/MM HH:MM (+Xxmin)',
  Other: ''
};

const stationMapping = {
  '[RETIMED] New STD: DD/MM HH:MM': 'New STD: DD/MM HH:MM',
  'STD Retimed': 'New STD: DD/MM HH:MM',
  '[DELAY] New ETD: DD/MM HH:MM (+Xxmin)': 'New ETD: DD/MM HH:MM (+Xxmin)',
  '[AOG]': 'Check with OCC for updates',
  '[CANCELLED]': 'Check with OCC for updates',
  '[RTB] Technical Assistance Required': 'Please standby at Gate [XX]',
  '[RTB] Station Assistance Required': 'Please standby at Gate [XX]',
  '[ATB] Technical Assistance Required': 'Please standby at Gate [XX]',
  '[ATB] Station Assistance Required': 'Please standby at Gate [XX]',
  '[DIVERTED] Technical Assistance Required': 'Please standby at Gate [XX]',
  '[DIVERTED] Station Assistance Required': 'Please standby at Gate [XX]',
  '[NEW FLIGHT PLAN REQUIRED]': '',
  '[GATE CHANGE]': 'New Gate: [GATE]',
  'ETD Delayed': 'New ETD: DD/MM HH:MM (+Xxmin)',
  Other: ''
};

const paxMapping = {
  '[RETIMED] New STD: DD/MM HH:MM': 'New STD: DD/MM HH:MM',
  'STD Retimed': 'New STD: DD/MM HH:MM',
  '[DELAY] New ETD: DD/MM HH:MM (+Xxmin)': 'New ETD: DD/MM HH:MM (+Xxmin)',
  '[AOG]': 'Check with OCC for updates',
  '[CANCELLED]': 'Check with OCC for updates',
  '[RTB] Technical Assistance Required': 'Standby for further',
  '[RTB] Station Assistance Required': 'Standby for further',
  '[ATB] Technical Assistance Required': 'Standby for further',
  '[ATB] Station Assistance Required': 'Standby for further',
  '[DIVERTED] Technical Assistance Required': 'Standby for further',
  '[DIVERTED] Station Assistance Required': 'Standby for further',
  '[NEW FLIGHT PLAN REQUIRED]': '',
  '[GATE CHANGE]': 'New Gate: [GATE]',
  'ETD Delayed': 'New ETD: DD/MM HH:MM (+Xxmin)',
  Other: ''
};

const dispatchMapping = {
  '[RETIMED] New STD: DD/MM HH:MM': `New STD: DD/MM HH:MM
New Flight Plan required`,
  'STD Retimed': `New STD: DD/MM HH:MM
New Flight Plan required`,
  '[DELAY] New ETD: DD/MM HH:MM (+Xxmin)': `New ETD: DD/MM HH:MM (+Xxmin)
New Flight Plan required (if delay > 30mins)`,
  '[AOG]': 'Check with OCC for updates',
  '[CANCELLED]': 'Check with OCC for updates',
  '[RTB] Technical Assistance Required': 'Standby for further',
  '[RTB] Station Assistance Required': 'Standby for further',
  '[ATB] Technical Assistance Required': 'Standby for further',
  '[ATB] Station Assistance Required': 'Standby for further',
  '[DIVERTED] Technical Assistance Required': 'Standby for further',
  '[DIVERTED] Station Assistance Required': 'Standby for further',
  '[NEW FLIGHT PLAN REQUIRED]': '',
  '[GATE CHANGE]': 'No broadcast',
  'ETD Delayed': `New ETD: DD/MM HH:MM (+Xxmin)
New Flight Plan required (if delay > 30mins)`,
  Other: ''
};

const roleToMapping = {
  [UserRole.PILOT]: pilotMapping,
  [UserRole.CABIN_CREW]: pilotMapping,
  [UserRole.ENGINEER]: engineeringMapping,
  [UserRole.OPS_MANAGER]: opsMapping,
  [UserRole.STATION_MANAGER]: stationMapping,
  [UserRole.PAX_SERVICES]: paxMapping,
  [UserRole.DISPATCH]: dispatchMapping
};

export const opsImpactMapping = (impact: string, data: any, role: UserRole) => {
  // @ts-expect-error
  const mapping = roleToMapping?.[role] || {};
  if (!mapping) {
    return impact;
  }
  let text = mapping?.[impact] || impact || '';
  if (!text && impact) {
    text = impact;
  }
  let callTime = '';
  if (data.std) {
    callTime = moment(data.std, 'DD/MM HH:mm')
      .add(-1, 'hours')
      .format('DD/MM HH:mm');
  }
  let flightPlanRequired = '';
  if (data?.minutes && parseInt(data.minutes) >= 30) {
    flightPlanRequired = 'New Flight Plan required';
  }
  return text
    .replace('New ETD: DD/MM HH:MM', `New ETD: ${data.startDate || ''}`)
    .replace('New STD: DD/MM HH:MM', `New STD: ${data.std || ''}`)
    .replace('New Call Time: DD/MM HH:MM', `New Call Time: ${callTime || ''}`)
    .replace('New Gate: [GATE]', `New Gate: ${data.gate || ''}`)
    .replace('+Xxmin', `+${data.minutes || '0'} minutes`)
    .replace(
      'New Flight Plan required (if delay > 30mins)',
      flightPlanRequired
    );
};

export const getTimestamp = (time: string) => {
  if (moment(time).isSame(moment(), 'day')) {
    return 'Today';
  }
  if (moment().subtract(1, 'day').isSame(time, 'day')) {
    return 'Yesterday';
  }
  return moment(time).format('ddd, DD/MM/YY');
};

export const threadNameForNotification = (thread: string) => {
  const temp = thread;
  switch (temp) {
    case UserRole.OCC:
      return 'OCC';
    case UserRole.ENGINEER:
      return 'Engineering';
    case UserRole.CABIN_CREW:
      return 'Cabin Crew';
    case UserRole.STATION_MANAGER:
      return 'Station Manager';
    case UserRole.PILOT:
      return 'Pilot';
    case UserRole.PAX_SERVICES:
      return 'Pax Services';
    case UserRole.DISPATCH:
      return 'Dispatch';
    case UserRole.OPS_MANAGER:
      return 'Ops Manager';
    default:
      if (temp.includes('_dest')) {
        return temp.replace('_dest', '') + ' Station Manager';
      }
      // flight - 16_09_24-SQ298-CHC-SIN
      // change to SQ298 17/09 Ops Update
      // eslint-disable-next-line no-case-declarations
      const data = temp.replace(/_/g, '/').split('-');
      // eslint-disable-next-line no-case-declarations
      const flightNumber = data[1];
      // eslint-disable-next-line no-case-declarations
      const date = data[0].replace(/_/g, '/');
      return `${flightNumber} ${date} Ops Update`;
  }
};
